import React from "react";
import PropTypes from 'prop-types';
import { CMS } from '../../../../utils';
import { withTrackComponentDisplayed, HSA_SEARCH_FORM_DATES_ERROR } from '../../../../utils/HtmlEvents';
import { ErrorUtils } from '../../../../utils/ErrorUtils';

export const DatePickerError = withTrackComponentDisplayed(({ validationErrorKey }) => {
    return (
        <span className="odf-label odf-text-sm odf-space-outer-xs">
            <CMS
                id={ErrorUtils.getDatesErrorKey(validationErrorKey)}
                values={ErrorUtils.getDatesErrorKeyArgs(validationErrorKey)}
            />
        </span>
    );
}, HSA_SEARCH_FORM_DATES_ERROR);

DatePickerError.propTypes = {
    validationErrorKey: PropTypes.object.isRequired,
}
